// AndroidArenaAudioAdapter.ts - Android Chromium-tailored audio platform adapter
import { IArenaAudioPlatformAdapter } from './IArenaAudioPlatformAdapter';

export class AndroidArenaAudioAdapter implements IArenaAudioPlatformAdapter {
  public readonly platformName = 'android';

  public createAudioContext(): AudioContext | null {
    if (typeof window === 'undefined') return null;
    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) return null;

    try {
      return new AudioCtx({ sampleRate: 48000, latencyHint: 'balanced' });
    } catch {
      try {
        return new AudioCtx({ sampleRate: 48000 });
      } catch {
        try {
          return new AudioCtx();
        } catch {
          return null;
        }
      }
    }
  }

  public prewarmAndUnlock(ctx: AudioContext, _isVoiceActive?: boolean): void {
    if (typeof window === 'undefined') return;

    if (ctx.state === 'suspended' || (ctx.state as any) === 'interrupted') {
      ctx.resume().catch(() => {});
    }

    // Pump Android AudioTrack buffer pipeline
    try {
      const buffer = ctx.createBuffer(1, 1, 22050);
      const source = ctx.createBufferSource();
      source.buffer = buffer;
      source.connect(ctx.destination);
      source.start(0);
    } catch {}
  }

  public onForeground(ctx: AudioContext | null, _isVoiceActive: boolean): void {
    if (ctx && (ctx.state === 'suspended' || (ctx.state as any) === 'interrupted')) {
      ctx.resume().catch(() => {});
    }
  }

  public onBackground(_ctx: AudioContext | null): void {
    // Avoid calling ctx.suspend() to prevent locking context into an explicit script-suspended state
  }

  public configureSession(_isVoiceActive: boolean): void {
    // Android routes automatically via AudioManager
  }

  public dispose(): void {}
}
